<template>
  <div class="trends-page">
    <div class="tway-title-hero"></div>
    <div class="article">
      <v-container class="pa-0">
        <breadcrumbs :items="breadcrumbs" class="ml-4 mr-4 ml-md-0 mr-md-0" />
        <div class="tway-headline-2 tway-morado--text ml-4 mr-4 ml-md-0 mr-md-0">
          {{ article.title }}
        </div>
        <div class="tway-body grey--text my-3 ml-4 mr-4 ml-md-0 mr-md-0" style="max-width: 730px">
          {{ article.author }}, {{ article.date }}
        </div>
        <div v-if="article.subtitle" class="tway-headline-3 black--text py-3">
          {{ article.subtitle }}
        </div>
        <br />
        <v-row class="ma-0 pa-0">
          <v-col
            class="ma-0 py-0 px-0 px-md-3  mb-6 mb-md-0"
            v-if="article.img"
            cols="12"
            xs="12"
            sm="12"
            md="5"
            lg="5"
            xl="5"
          >
            <v-img
              :src="require(`@/assets/images/articles/${article.img}`)"
              contain
              width="100%"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div class="tway-body grey--text mt-2">
              {{ article.caption }}
            </div>
          </v-col>
          <v-col
            class="ma-0 py-0 px-3"
            justify-self="space-between"
            cols="12"
            xs="12"
            sm="12"
            md="7"
            lg="7"
            xl="7"
          >
            <div class="column-justify-between">
              <div>
                <div
                  v-if="article.body !== null"
                  class="d-flex align-start flex-column"
                >
                  <p v-html="article.body" />
                  <!-- <tag-group :tags="article.tags" /> -->
                </div>
                <div v-if="article.questions !== null">
                  <div
                    v-for="(question, n) in article.questions"
                    :key="n"
                    class="mb-3"
                  >
                    <span class="tway-morado--text font-weight-bold">
                      {{ n + 1 }}.
                    </span>
                    <span>
                      {{ question }}
                    </span>
                  </div>
                </div>
                <div v-if="article.href">
                  <v-btn
                    text
                    :href="article.href"
                    target="_blank"
                    color="tway-morado"
                  >
                    <v-icon left>mdi-eye-outline</v-icon>
                    Ver artículo completo aquí
                  </v-btn>
                </div>
              </div>
              <v-row class="ma-0 pa-0" justify="end">
                <v-col class="ma-0 pa-0" align-self="end">
                  <v-row>
                    <br />
                    <v-chip
                      class="ma-2"
                      color="tway-verde-manzana"
                      text-color="white"
                      v-for="article in article.tags"
                      :key="article"
                    >
                      {{ article.label }}
                    </v-chip>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <br /><br /><br />
    </div>
  </div>
</template>

<style scoped>
.column-justify-between {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
<script>
import Breadcrumbs from "@/components/Breadcrumbs";
// import TagGroup from '@/components/TagGroup';

import TrendsNewsJSON from "@/utils/trends-news.json";

export default {
  name: "TrendsPost",

  components: {
    Breadcrumbs,
    // TagGroup
  },

  data: () => ({
    breadcrumbs: [
      {
        text: "Tendencias",
        disabled: false,
        exact: true,
        to: {
          name: "trends",
        },
      },
      {
        text: "",
        disabled: true,
        exact: true,
        to: {
          name: "trends-post",
        },
      },
    ],
    posts: TrendsNewsJSON,
    article: {
      id: null,
      title: null,
      subtitle: null,
      author: null,
      date: null,
      body: null,
      img: null,
      caption: null,
      tags: [],
    },
  }),

  created() {
    this.article.id = this.$route.params.id;
    this.getArticle();
  },

  methods: {
    getArticle() {
      this.article = this.posts.find((p) => p.id === this.article.id);
      this.breadcrumbs[1].text = this.article.title;
    },
  }
};
</script>

<style scoped>
.article {
  padding-top: 50px;
  padding-bottom: 50px;
}
</style>